import { render, staticRenderFns } from "./CustomAttributes.vue?vue&type=template&id=a8012dea&scoped=true"
import script from "./CustomAttributes.vue?vue&type=script&lang=js"
export * from "./CustomAttributes.vue?vue&type=script&lang=js"
import style0 from "./CustomAttributes.vue?vue&type=style&index=0&id=a8012dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8012dea",
  null
  
)

export default component.exports